import type { ReactNode } from "react";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";

export function PageShell({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-screen flex flex-col grain">
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}

export function PageHero({
  eyebrow,
  title,
  description,
  image,
  video,
  children,
}: {
  eyebrow?: string;
  title: ReactNode;
  description?: string;
  image?: string;
  video?: string;
  children?: ReactNode;
}) {
  return (
    <section className="relative min-h-[520px] overflow-hidden bg-black">
      {video ? (
        <video
          autoPlay
          muted
          loop
          playsInline
          className="absolute inset-0 h-full w-full object-cover"
        >
          <source src={video} type="video/mp4" />
        </video>
      ) : (
        image && (
          <img
            src={image}
            alt={typeof title === "string" ? title : "Hero image"}
            className="absolute inset-0 h-full w-full object-cover opacity-70"
          />
        )
      )}

      <div className="absolute inset-0 bg-gradient-to-r from-black via-black/65 to-black/10" />

      <div className="container-bizu relative z-10 flex min-h-[520px] items-center py-24">
        <div className="max-w-3xl">
          <p className="mb-5 text-sm font-bold uppercase tracking-[0.35em] text-accent">
            {eyebrow}
          </p>

          <h1 className="text-4xl font-black uppercase leading-tight text-white md:text-6xl">
            {title}
          </h1>

          {description && (
            <p className="mt-6 text-lg leading-relaxed text-white/85">{description}</p>
          )}

          {children && <div className="mt-8">{children}</div>}
        </div>
      </div>
    </section>
  );
}
